import React, { MouseEvent } from 'react'
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Typography,
} from '@material-ui/core'
import {useTranslation} from 'react-i18next'

export interface DialogConfirmActionProps {
    onCancel: () => void
    onAgree: () => void
    state: boolean
    title: string
    content: string
}
const DialogConfirmAction: React.FC<DialogConfirmActionProps> = ({
    content,
    onCancel,
    onAgree,
    state,
    title,
}) => {
    const {t} = useTranslation(["common"])
    return (
        <Dialog
            open={state}
            onClose={onCancel}
            aria-labelledby="alert-dialog"
            aria-describedby="alert-dialog"
            maxWidth={'xs'}
            fullWidth
        >
            <DialogTitle id="alert-dialog-title" disableTypography={true}>
                <Typography variant={'h4'}>{title}</Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText variant={'subtitle1'} id="alert-dialog">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                {t("no")}
    </Button>
                <Button onClick={onAgree} color="primary" autoFocus>
                {t("yes")}
    </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogConfirmAction
